/**
 * GTM Tracking pour Shopify
 * Gère les événements: PageView, ViewContent, AddToCart, InitiateCheckout
 */

// Initialisation du dataLayer si pas déjà présent
window.dataLayer = window.dataLayer || [];

/**
 * Fonction utilitaire pour pousser des événements vers GTM
 */
function pushToDataLayer(eventData) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push(eventData);
    console.log('GTM Event:', eventData); // Debug (à retirer en production si besoin)
  }
}

/**
 * 1. PageView - Déclenché automatiquement par GTM
 * Mais on peut aussi le déclencher manuellement si besoin
 */
function trackPageView() {
  pushToDataLayer({
    event: 'pageView',
    page: {
      url: window.location.href,
      title: document.title,
      path: window.location.pathname
    }
  });
}

/**
 * 2. ViewContent - Sur les pages produit
 */
function trackViewContent(product) {
  if (!product) return;

  const variant = product.selected_or_first_available_variant || product.variants?.[0];
  if (!variant) return;

  const currency = window.Shopify?.currency?.active || window.Shopify?.shop?.currency || window.Shopify?.locale?.currency || 'EUR';
  const price = variant.price ? (variant.price / 100).toFixed(2) : '0.00';

  const eventData = {
    event: 'viewContent',
    ecommerce: {
      currency: currency,
      value: price,
      items: [{
        item_id: variant.id?.toString() || '',
        item_name: product.title || '',
        item_variant: variant.title || '',
        price: price,
        currency: currency,
        quantity: 1
      }]
    },
    product: {
      id: variant.id?.toString() || '',
      name: product.title || '',
      variant: variant.title || '',
      price: parseFloat(price),
      currency: currency,
      sku: variant.sku || '',
      vendor: product.vendor || ''
    }
  };

  pushToDataLayer(eventData);
}

/**
 * 3. AddToCart - Quand un produit est ajouté au panier
 */
function trackAddToCart(product, variant, quantity = 1) {
  if (!product || !variant) {
    console.warn('GTM Tracking: Données produit ou variante manquantes pour AddToCart');
    return;
  }

  const currency = window.Shopify?.currency?.active || window.Shopify?.shop?.currency || window.Shopify?.locale?.currency || 'EUR';
  const variantPrice = variant.price || 0;
  const price = (variantPrice / 100).toFixed(2);
  const totalValue = ((variantPrice * quantity) / 100).toFixed(2);

  // Éviter les doublons - vérifier si l'événement a déjà été envoyé récemment
  const lastEventKey = 'gtm_last_addtocart_' + variant.id + '_' + quantity;
  const lastEventTime = sessionStorage.getItem(lastEventKey);
  const now = Date.now();
  
  if (lastEventTime && (now - parseInt(lastEventTime)) < 2000) {
    // Événement déjà envoyé il y a moins de 2 secondes, ignorer
    return;
  }
  
  sessionStorage.setItem(lastEventKey, now.toString());

  const eventData = {
    event: 'addToCart',
    ecommerce: {
      currency: currency,
      value: totalValue,
      items: [{
        item_id: variant.id?.toString() || '',
        item_name: product.title || '',
        item_variant: variant.title || '',
        price: price,
        currency: currency,
        quantity: quantity
      }]
    },
    product: {
      id: variant.id?.toString() || '',
      name: product.title || '',
      variant: variant.title || '',
      price: parseFloat(price),
      currency: currency,
      quantity: quantity,
      sku: variant.sku || '',
      vendor: product.vendor || ''
    }
  };

  pushToDataLayer(eventData);
}

/**
 * 4. InitiateCheckout - Quand l'utilisateur clique sur checkout
 */
function trackInitiateCheckout(cart) {
  if (!cart || !cart.items || cart.items.length === 0) {
    console.warn('GTM Tracking: Panier vide pour InitiateCheckout');
    return;
  }

  const currency = window.Shopify?.currency?.active || window.Shopify?.shop?.currency || window.Shopify?.locale?.currency || cart.currency || 'EUR';
  
  const items = cart.items.map(item => {
    const itemPrice = item.price || item.final_price || 0;
    return {
      item_id: (item.variant_id || item.id)?.toString() || '',
      item_name: item.product_title || item.title || item.name || '',
      item_variant: item.variant_title || item.variant_name || '',
      price: (itemPrice / 100).toFixed(2),
      currency: currency,
      quantity: item.quantity || 1
    };
  });

  const totalPrice = cart.total_price || cart.totalPrice || 0;
  const totalValue = totalPrice > 0 ? (totalPrice / 100).toFixed(2) : 
    items.reduce((sum, item) => sum + (parseFloat(item.price) * item.quantity), 0).toFixed(2);

  // Éviter les doublons
  const lastCheckoutKey = 'gtm_last_checkout';
  const lastCheckoutTime = sessionStorage.getItem(lastCheckoutKey);
  const now = Date.now();
  
  if (lastCheckoutTime && (now - parseInt(lastCheckoutTime)) < 5000) {
    // Événement déjà envoyé il y a moins de 5 secondes, ignorer
    return;
  }
  
  sessionStorage.setItem(lastCheckoutKey, now.toString());

  const eventData = {
    event: 'initiateCheckout',
    ecommerce: {
      currency: currency,
      value: totalValue,
      items: items
    },
    cart: {
      total: totalValue,
      currency: currency,
      item_count: cart.item_count || cart.itemCount || items.reduce((sum, item) => sum + item.quantity, 0)
    }
  };

  pushToDataLayer(eventData);
}

// Exposer les fonctions globalement
window.GTMTracking = {
  trackPageView,
  trackViewContent,
  trackAddToCart,
  trackInitiateCheckout
};

// Auto-track ViewContent sur les pages produit au chargement
document.addEventListener('DOMContentLoaded', function() {
  // Vérifier si on est sur une page produit
  if (window.Shopify?.theme?.product) {
    // Attendre un peu pour être sûr que GTM est chargé
    setTimeout(function() {
      trackViewContent(window.Shopify.theme.product);
    }, 500);
  }

  // Écouter les changements de variante pour mettre à jour ViewContent
  const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
  variantInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (window.Shopify?.theme?.product) {
        const variantId = parseInt(this.value);
        const variant = window.Shopify.theme.product.variants.find(v => v.id === variantId);
        if (variant) {
          // Mettre à jour la variante sélectionnée
          window.Shopify.theme.product.selected_or_first_available_variant = variant;
          // Retracker ViewContent avec la nouvelle variante
          trackViewContent(window.Shopify.theme.product);
        }
      }
    });
  });

  // Écouter les événements d'ajout au panier
  // Plusieurs méthodes pour détecter l'ajout au panier car le code peut être obfusqué
  
  // Méthode 1: Écouter les événements personnalisés
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.product) {
      const product = event.detail.product;
      const variant = event.detail.variant || window.Shopify?.theme?.product?.selected_or_first_available_variant;
      const quantity = event.detail.quantity || 1;
      trackAddToCart(product, variant, quantity);
    }
  });

  // Méthode 2: Observer les changements dans le DOM (cart notification, etc.)
  const cartObserver = new MutationObserver(function(mutations) {
    const cartNotification = document.getElementById('cart-notification');
    if (cartNotification && cartNotification.classList.contains('active')) {
      // Délai pour laisser le temps au panier de se mettre à jour
      setTimeout(function() {
        // Récupérer les données depuis le panier
        if (window.Shopify?.theme?.product) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              if (cart.items && cart.items.length > 0) {
                // Prendre le dernier item ajouté (généralement le plus récent)
                const lastItem = cart.items[cart.items.length - 1];
                const variant = window.Shopify.theme.product.variants.find(v => 
                  v.id === lastItem.variant_id
                );
                
                if (variant && window.GTMTracking) {
                  window.GTMTracking.trackAddToCart(
                    window.Shopify.theme.product,
                    variant,
                    lastItem.quantity || 1
                  );
                }
              }
            })
            .catch(function(error) {
              console.error('Erreur lors de la récupération du panier:', error);
            });
        }
      }, 500);
    }
  });

  // Observer les changements dans le body pour détecter les notifications de panier
  if (document.body) {
    cartObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Écouter les clics sur les boutons checkout
  // Utiliser la délégation d'événements pour capturer les boutons créés dynamiquement
  document.addEventListener('click', function(e) {
    const target = e.target;
    const checkoutButton = target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout, [id*="checkout"]');
    const checkoutForm = target.closest('form[action*="checkout"]');
    
    if (checkoutButton || (checkoutForm && target.type === 'submit')) {
      // Récupérer les données du panier
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.items && cart.items.length > 0 && window.GTMTracking) {
            window.GTMTracking.trackInitiateCheckout(cart);
          }
        })
        .catch(error => {
          console.error('Erreur lors de la récupération du panier:', error);
        });
    }
  }, true); // Utiliser capture phase pour intercepter avant les autres handlers
});

// Fonction pour tracker AddToCart depuis un événement externe
// Cette fonction peut être appelée depuis main.js après l'ajout au panier
function trackAddToCartFromCartResponse(cartResponse, variantId) {
  if (!cartResponse || !variantId) return;

  // Récupérer les informations du produit depuis le panier
  const cartItem = cartResponse.items?.find(item => item.variant_id === variantId);
  if (cartItem && window.Shopify?.theme?.product) {
    const product = window.Shopify.theme.product;
    const variant = product.variants.find(v => v.id === variantId) || 
                   product.selected_or_first_available_variant;
    
    if (variant) {
      trackAddToCart(product, variant, cartItem.quantity || 1);
    }
  }
}

// Exposer également cette fonction
window.GTMTracking.trackAddToCartFromCartResponse = trackAddToCartFromCartResponse;

